import React from 'react';
import { Box, Pagination, Typography } from '@mui/material';

interface TablePaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
}

const TablePaginationBar: React.FC<TablePaginationProps> = ({
  page,
  pageSize,
  total,
  onChange,
}) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        mt: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Showing {from}–{to} of {total}
      </Typography>
      <Pagination
        count={pages}
        page={page}
        onChange={(_, value) => onChange(value)}
        color="primary"
        shape="rounded"
        size="small"
      />
    </Box>
  );
};

export default TablePaginationBar;
